import { render, staticRenderFns } from "./signConfig.vue?vue&type=template&id=298b4718&scoped=true"
import script from "./signConfig.vue?vue&type=script&lang=js"
export * from "./signConfig.vue?vue&type=script&lang=js"
import style0 from "./signConfig.vue?vue&type=style&index=0&id=298b4718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b4718",
  null
  
)

export default component.exports